import React, { useState } from "react";
import "../../assets/css/homeSearch.css";
import searchIcon from '../../assets/images/blue.svg'
import { Link } from "react-router-dom";

const HomeSearch = ({ to, onSearch = () => {},  ...props }) => {
  const [search, setSearch] = useState('')

  return (
    <div className="search-bar-container">
    <div className="search-input-wrapper">
      <span className="search-icon d-flex">
        <img src={searchIcon} alt="" />
      </span>
      <input
        type="text"
        placeholder="Search for City, Dharamshala or Hotel"
        className="search-input"
        value={search}
        onChange={e => setSearch(e.target.value)}
        onKeyDown={e =>  (e.key === "Enter" && e.keyCode === 13) && (onSearch(search), setSearch("")) }
        { ...props }
      />

      {
        to 
        ? <Link to={to} className="search-button">Search</Link>
        : <button className="search-button"  onClick={() => (onSearch(search), setSearch(""))}>Search</button>
      }
    </div>
  </div>
  );
};

export default HomeSearch;
